export const COMPLAINT_REQUIREMENT_LIST_REQUEST =
  "COMPLAINT_REQUIREMENT_LIST_REQUEST";
export const COMPLAINT_REQUIREMENT_LIST_SUCCESS =
  "COMPLAINT_REQUIREMENT_LIST_SUCCESS";
export const COMPLAINT_REQUIREMENT_LIST_FAIL =
  "COMPLAINT_REQUIREMENT_LIST_FAIL";
export const COMPLAINT_REQUIREMENT_LIST_RESET =
  "COMPLAINT_REQUIREMENT_LIST_RESET";

export const COMPLAINT_REQUIREMENT_SINGLE_REQUEST =
  "COMPLAINT_REQUIREMENT_SINGLE_REQUEST";
export const COMPLAINT_REQUIREMENT_SINGLE_SUCCESS =
  "COMPLAINT_REQUIREMENT_SINGLE_SUCCESS";
export const COMPLAINT_REQUIREMENT_SINGLE_FAIL =
  "COMPLAINT_REQUIREMENT_SINGLE_FAIL";
export const COMPLAINT_REQUIREMENT_SINGLE_RESET =
  "COMPLAINT_REQUIREMENT_SINGLE_RESET";

export const CREATE_COMPLAINT_REQUIREMENT_REQUEST =
  "CREATE_COMPLAINT_REQUIREMENT_REQUEST";
export const CREATE_COMPLAINT_REQUIREMENT_SUCCESS =
  "CREATE_COMPLAINT_REQUIREMENT_SUCCESS";
export const CREATE_COMPLAINT_REQUIREMENT_FAIL =
  "CREATE_COMPLAINT_REQUIREMENT_FAIL";
export const CREATE_COMPLAINT_REQUIREMENT_RESET =
  "CREATE_COMPLAINT_REQUIREMENT_RESET";

export const UPDATE_COMPLAINT_REQUIREMENT_REQUEST =
  "UPDATE_COMPLAINT_REQUIREMENT_REQUEST";
export const UPDATE_COMPLAINT_REQUIREMENT_SUCCESS =
  "UPDATE_COMPLAINT_REQUIREMENT_SUCCESS";
export const UPDATE_COMPLAINT_REQUIREMENT_FAIL =
  "UPDATE_COMPLAINT_REQUIREMENT_FAIL";
export const UPDATE_COMPLAINT_REQUIREMENT_RESET =
  "UPDATE_COMPLAINT_REQUIREMENT_RESET";

export const DELETE_COMPLAINT_REQUIREMENT_REQUEST =
  "DELETE_COMPLAINT_REQUIREMENT_REQUEST";
export const DELETE_COMPLAINT_REQUIREMENT_SUCCESS =
  "DELETE_COMPLAINT_REQUIREMENT_SUCCESS";
export const DELETE_COMPLAINT_REQUIREMENT_FAIL =
  "DELETE_COMPLAINT_REQUIREMENT_FAIL";
export const DELETE_COMPLAINT_REQUIREMENT_RESET =
  "DELETE_COMPLAINT_REQUIREMENT_RESET";
